<template>
  <div class="checkout-container">
    <div class="checkout-container-left signin-left-background" />
    <div class="checkout-container-right">
      <!-- Top Header -->
      <div class="top-header-container">
        <img
          class="logo largeLogo"
          src="/images/dark-logo.svg"
          alt="Leland Little Auctions"
        >
        <label>AUCTION ITEM CHECKOUT</label>
      </div>

      <div class="details-container">
        <h1>Auction Items Checkout</h1>

        <p class="signin-subtitle">
          Please confirm your login with the credentials sent to your inbox.
        </p>

        <div v-if="errorMessage !== null">
          <p class="login-error">
            {{ errorMessage }}
          </p>
        </div>

        <div v-if="twoFactorRequest.length > 0">
          <div class="majorTitle">
            This account is protected with two-factor authentication.
          </div>
          <div class="textLeft paddingLargeLeft paddingLargeRight paddingLargeBottom marginNormalBottom">
            A verification code has been sent to your phone; please enter it below.
          </div>
          <div class="row textLeft">
            <div class="twelve columns">
              <input
                id="pin"
                v-model="pin"
                type="text"
                name="pin"
                required
              >
              <input
                id="two_factor_token"
                v-model="twoFactorRequest"
                type="hidden"
                name="two_factor_token"
                required
              >
            </div>
          </div>

          <div class="paddingNormalBottom">
            <ApiResponse :context="'send_two_factor_pin'" />
          </div>

          <div class="row">
            <button
              v-if="(typeof (apiPending.send_two_factor_pin) !== 'undefined')"
              class="disabledButton bidButton u-full-width"
              disabled="disabled"
            >
              <span class="loading" />
            </button>
            <button
              v-else
              type="submit"
              class="bidButton backgroundColorDefault u-full-width"
              @click="sendTwoFactorPin('send_two_factor_pin')"
            >
              Continue
            </button>
          </div>
        </div>

        <div v-else-if="authenticateWithPassword">
          <div class="signin-name">
            <label>Email</label>
            <input
              id="username"
              v-model="credentials.username"
              placeholder="Email"
              type="text"
              name="username"
              required
            >
          </div>

          <div class="signin-pw">
            <label>Password</label>
            <input
              id="password"
              v-model="credentials.password"
              placeholder="Password"
              type="password"
              name="password"
              required
            >
          </div>

          <button
            class="continue-btn"
            @click="authenticate('log_in_with_password')"
          >
            Continue
          </button>
        </div>
      </div>

      <!-- Bottom Footer -->
      <div class="bottom-footer-container">
        <button @click="exit()">
          Exit
        </button>
      </div>
    </div>

    <LoadingOverlayComponent
      v-if="showLoading"
      :title="loadingTitle"
    />
  </div>
</template>

<script>
import LoadingOverlayComponent from '@/components/Shared/LoadingOverlayComponent.vue'
import apiMixin from '@/mixins/apiMixin.js'

export default {
	name: 'SignInCheckoutComponent',
	components: {
		LoadingOverlayComponent
	},
	mixins: [apiMixin],
	data () {
		return {
			'authenticateWithPassword': true,
			'showPasswordlessMessage': false,
			'showCreateAccount': false,
			'credentials': {
				'username': null,
				'password': null
			},
			pin: '',
			'verify_email': '',
			loadingTitle: 'Signing in...',
			isLoading: false,
			errorMessage: null
		}
	},

	computed: {
		showLoading: function () {
			if (this.isLoading) {
				return true
			}

			return false
		},
		apiResponse: function () {
			return this.$store.getters.apiResponse
		},
		authenticated: function () {
			return this.$store.getters.isAuthenticated
		},
		apiPending: function () {
			return this.$store.getters.apiPending
		},
		twoFactorRequest: function () {
			return this.$store.getters.twoFactorRequest
		}
	},
	watch: {
		authenticated: function () {
			if (this.authenticated) {
				this.$router.push({ name: 'auctionItems' })
			}
		},
		apiResponse: function () {
			if (typeof this.apiResponse.log_in_with_password !== 'undefined') {
				if (this.apiResponse.log_in_with_password.result === 'failure') {
					this.errorMessage = this.apiResponse.log_in_with_password.message
					this.isLoading = false

					console.error(this.errorMessage)
				}
			}
		}
	},

	mounted () {
		if (this.authenticated) {
			this.$router.push({ name: 'auctionItems' })
		}
	},

	methods: {
		authenticate (context) {
			this.isLoading = true
			let payload = {
				'username': this.credentials.username,
				'password': this.credentials.password,
				'context': context
			}
			this.$store.dispatch('authenticate', payload)
		},
		sendTwoFactorPin (context) {
			let payload = {
				'pin': this.pin,
				'two_factor_token': this.twoFactorRequest,
				'context': context
			}
			this.$store.dispatch('authenticate', payload)
		},
		passwordlessLogin (context) {
			let payload = {
				'username': this.credentials.username,
				'password': this.credentials.password,
				'verify_email': this.verify_email,
				'context': context
			}
			this.$store.dispatch('passwordlessLogin', payload)
		},
		exit () {
			const referrer = localStorage.getItem('exit-referrer')
			if (referrer) {
				// If we have a exit-referrer, redirect to it
				window.location.replace(referrer)
				return
			}
			// Otherwise, redirect to the home page
			window.location.replace(this.getUrlHost(this.$store.getters.apiPath))
		}
	}
}
</script>

<style scoped></style>
